import React, { Fragment, useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import {
  Row,
  Nav,
  Navbar,
  NavDropdown,
  Col,
  Container,
  Tab,
  Offcanvas,
} from "react-bootstrap";
import megaMeunLogo from "@styles/assets/images/Logo/offzname-logo-removebg-preview.png";
import TalkToUs from "./talk-to-us";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import Loading from "./loading";
import { useForm } from "react-hook-form";
import { Country } from "country-state-city";
import { collection, addDoc } from "firebase/firestore/lite";
import { utils } from "@core/helper";
import { collectionKeys } from "@core/helper/utils";

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const validationSchema = Yup.object().shape({
  name: Yup.string().label("Name").required(),
  email: Yup.string()
    .matches(emailRegex, "Invalid email address")
    .label("Email")
    .required(),
  country: Yup.string().label("Country").required(),
  mobile: Yup.string().label("Contact").required(),
  content: Yup.string().label("Content").required(),
  service: Yup.string().label("Service").required(),
});

const LandingHeader = (props) => {
  const { db } = props;
  const [loading, setLoading] = useState(false);
  const [talkToUsShow, setTalkToUsShow] = useState(false);
  const [toggleMegaMenuShow, setToggleMegaMenuShow] = useState(false);
  const [isHomePage, setIsHomePage] = useState(false);
  const [toggleShow, setToggleShow] = useState(false);

  const handleToggleShow = () => setToggleShow(!toggleShow);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleToggleTalkToUs = () => {
    setTalkToUsShow(!talkToUsShow);
    reset();
  };
  const handleToggleMegaMenu = () => setToggleMegaMenuShow(!toggleMegaMenuShow);
  const countries = Country.getAllCountries();

  const handleOnSubmit = async (values) => {
    const { name, email, country, content, mobile, service } = values;
    const payload = {
      name,
      email,
      country,
      content,
      mobile,
      service,
      date: new Date(),
      status: true,
    };
    setLoading(true);
    try {
      const clients = collection(db, collectionKeys.CLIENTS);
      await addDoc(clients, payload);
      utils.showSuccssMsg("We will contact/talk to you soon");
      reset();
      setLoading(false);
      setTimeout(() => {
        handleToggleTalkToUs();
      }, 1000);
    } catch (e) {
      utils.showErrMsg("Error adding document");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (typeof window !== `undefined` || undefined) {
      const { pathname } = window.location;
      setIsHomePage(pathname === "/" ? false : true);
    }
  }, []);

  useEffect(() => {
    if (toggleMegaMenuShow) {
      document.body.classList.add('lock-scroll');
    } else {
      document.body.classList.remove('lock-scroll');
    }
  }, [toggleMegaMenuShow]);


  return (
    <Fragment>
      <Navbar
        expand="lg"
        className={`header_main header_wrapper position-fixed 
        ${isHomePage ? "" : "landing_header_bg"}
         `}
      >
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            {" "}
            <StaticImage
              width={73}
              height={50}
              className="logoheader"
              src="../../styles/assets/images/Logo/new_logo.png"
              alt="jusstry technologies"
            />
          </Navbar.Brand>
          {/* <Navbar.Toggle aria-controls="navbarScroll" /> */}

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={handleToggleShow}
            // aria-hidden="true"
            className={`${toggleShow ? "x collapsed" : ""}`}
          >
            <div className="icon-bar"></div>
            <div className="icon-bar"></div>
            <div className="icon-bar"></div>
          </Navbar.Toggle>
          <Navbar.Collapse id="navbarScroll">
            <Nav className="mx-auto my-2 my-lg-0">
              <Nav.Link as={Link} onClick={handleToggleMegaMenu} to="#">
                Services
              </Nav.Link>
              <Nav.Link as={Link} to="/blog/" rel="preload">
                Blogs
              </Nav.Link>
              <Nav.Link as={Link} to="/portfolio/" rel="preload">
                Portfolio
              </Nav.Link>
              <Nav.Link as={Link} to="/contact-us/" rel="preload">
                Contact us
              </Nav.Link>
              <NavDropdown
                title="Company"
                id="navbarScrollingDropdown"
                className="industries_dropdown"
              >
                <div className="industries_ddown_lhs">
                  <NavDropdown.Item as={Link} to="/contact-us/" rel="preload">
                    Pitch Deck
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/privacy-policy/"
                    rel="preload"
                  >
                    Privacy Policy
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/terms-condition/"
                    rel="preload"
                  >
                    Terms & Conditions
                  </NavDropdown.Item>
                </div>
              </NavDropdown>
            </Nav>
            <div className="header_left">
              <button
                type="submit"
                className="primary_btn"
                onClick={handleToggleTalkToUs}
              >
                Talk to us
              </button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Offcanvas
        backdrop={true}
        scroll={false}
        show={toggleMegaMenuShow}
        onHide={handleToggleMegaMenu}
        placement="end"
        className="offcanvas-mega-menu w-100"
      >
        <Offcanvas.Header closeButton>
          <Link to="/">
            <img
              className="mega_menu_logoheader"
              id="offcanvasRightLabel"
              src={megaMeunLogo}
              alt="justtry-logo"
            />
          </Link>
        </Offcanvas.Header>
        <Offcanvas.Body className="canvas-body">
          <Container fluid>
            <Row>
              <Tab.Container defaultActiveKey="services">
                <div className="mega-menu">
                  <div className="d-flex align-items-start">
                    <Nav
                      className="main-menu flex-column first_nav_list"
                      variant="pills"
                    >
                      <Nav.Item>
                        <Nav.Link to="#" eventKey="products">
                          Products
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link to="#" eventKey="services">
                          Services
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link to="#" eventKey="industries">
                          Industries
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link>
                          <Link to="/blog/">Blogs</Link>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link>
                          <Link to="/contact-us/">Contact us</Link>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="products" className="ms-5">
                        <Nav className="main-menu flex-column " variant="pills">
                          <Nav.Item>
                            <Link
                              className="nav-link"
                              to="/matrimony-clone-script"
                            >
                              Truefriend Matrimony
                            </Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Link className="nav-link" to="/clone-script/">
                              Clone script
                            </Link>
                          </Nav.Item>
                        </Nav>
                      </Tab.Pane>
                      <Tab.Pane eventKey="industries" className="ms-5">
                        <Nav
                          className="main-menu flex-column justify-content-start "
                          variant="pills"
                        >
                          <Nav.Item>
                            <Nav.Link to="#" onClick={handleToggleTalkToUs}>
                              Retail
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link to="#" onClick={handleToggleTalkToUs}>
                              Automobiles
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link to="#" onClick={handleToggleTalkToUs}>
                              Transportation
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link onClick={handleToggleTalkToUs} to="#">
                              Ecommerce
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link onClick={handleToggleTalkToUs} to="#">
                              Manufacturing
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link onClick={handleToggleTalkToUs} to="#">
                              Supply Chain
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link onClick={handleToggleTalkToUs} to="#">
                              Crypto
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link onClick={handleToggleTalkToUs} to="#">
                              Social Networking
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="services"
                        className="service-tab-content d-flex ms-5"
                      >
                        <Tab.Container id="left-tabs-example">
                          <Nav
                            variant="pills"
                            className="main-menu main_menu_fix_width flex-column"
                          >
                            <Nav.Item>
                              <Nav.Link eventKey="web3" to="#">
                                Web3 Development
                              </Nav.Link>
                              {/* Web3 Development Mobile Responsive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="web3"
                                    defaultActiveKey="web3"
                                    className="main-menu "
                                  >
                                    <Nav
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          to="/web3-development-company/"
                                          className="nav-link"
                                        >
                                          Web3 Development Company
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/blog/tokenization-in-revolutionizing-blockchain/"
                                        >
                                          Token Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          ICO Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/dao-development-company/"
                                        >
                                          DAO Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/ton-wallet-development-company/"
                                        >
                                          Ton wallet Development Company
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="web2" to="#">
                                Web2 Development
                              </Nav.Link>
                              {/* Web2 Development Mobile Responsive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="web2"
                                    className="main-menu "
                                  >
                                    <Nav
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/custom-web-development-company/"
                                        >
                                          Custom Web Design & Development{" "}
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          UI / UX Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/blog/ecommerce-automotive-industry"
                                        >
                                          E-Commerce Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Mobile App Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/stock-trading-app-development-company"
                                        >
                                          Stock Trading Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/mean-and-mern-full-stack-development/"
                                        >
                                          MEAN / MERN Stack Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="active_page_link nav-link"
                                          to="/poc-development-company/"
                                        >
                                          POC Open Source Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          QA Testing
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link d-flex align-items-center justify-content-between "
                                          to="/blog/how-to-build-software-product-guide-for-beginners/"
                                        >
                                          <span>
                                            Demand based Web Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link eventKey="crypto" to="#">
                                Crypto Exchange Development
                              </Nav.Link>
                              {/* Crypto Exchange Mobile Responsive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="crypto"
                                    className="main-menu"
                                  >
                                    <Nav
                                      className="main-menu flex-column align-items-start"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-center nav-link"
                                          to="/cryptocurrency-exchange-development-company/"
                                        >
                                          <span>
                                            Crypto Currency Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-center nav-link"
                                          to="/centralized-crypto-exchange-development/"
                                        >
                                          <span>
                                            Centralized Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-content-center justify-content-center nav-link"
                                          to="/decentralized-exchange-development/"
                                        >
                                          <span>
                                            Decentralized Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-center nav-link"
                                          to="/p2p-crypto-exchange-development/"
                                        >
                                          <span>
                                            P2P Crypto Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link"
                                          to="/smart-contract-development-company/"
                                        >
                                          <span>
                                            Smart Contract Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link"
                                          to="/white-label-crypto-exchange-development/"
                                        >
                                          <span>
                                            White-Label Crypto Exchange
                                            Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Crypto Banking Software
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link eventKey="mlm" to="#">
                                MLM
                              </Nav.Link>
                              {/* Dapp Development Mobile Respondive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="mlm"
                                    className="main-menu "
                                  >
                                    <Nav
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/cryptocurrency-mlm-software-development/"
                                        >
                                          Crypto MLM Software Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="blockchain" to="#">
                                Blockchain Development
                              </Nav.Link>
                              {/* Blockchain Development Mobile Responsive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="blockchain"
                                    className="main-menu "
                                  >
                                    <Nav
                                      // style={{ width: "295px" }}
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link"
                                          to="/enterprise-blockchain-development/"
                                        >
                                          <span>
                                            Enterprise Blockchain Development{" "}
                                            {utils.linkIcon()}
                                          </span>
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain Consulting & Development
                                          Service
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-center nav-link"
                                          to="/web3-smart-contract-development-company/"
                                        >
                                          <span>
                                            Smart Contract Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Private Blockchain Development
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Hybrid Finance Blockchain Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Layer 1 and Layer 2 Solutions
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link d-flex justify-content-between "
                                          to="/blog/blockchain-supply-chain/"
                                        >
                                          <span>Blockchain in Supplychain</span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/blog/blockchain-in-pharma-industry/"
                                        >
                                          Blockchain in Healthcare
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain in Realestate
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain in Insurance
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Protocol Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain Frameworks
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Binance smart chain Blockchain
                                          Development
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="nft" to="#">
                                NFT Development
                              </Nav.Link>
                              {/* NFT Development Mobile Responsive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="nft"
                                    className="main-menu "
                                  >
                                    <Nav
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/nft-development-company/"
                                        >
                                          NFT Development Company{" "}
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/nft-marketplace-development-company/"
                                        >
                                          NFT Marketplace Development{" "}
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Gaming Platform Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Staking platform Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Minting platform Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Smart Contract Development
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Marketplace platform like Opensea
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Polygon NFT Marketplace Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Exchange Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Token Development
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="defi" to="#">
                                DeFi
                              </Nav.Link>
                              {/* DeFi Development Mobile Responsive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="defi"
                                    className="main-menu "
                                  >
                                    <Nav
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/defi-development-company/"
                                        >
                                          DeFi Development Company{" "}
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          DeFi Smart Contract Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          DeFi Yield Farming Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          DApp Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          DeFi Token Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          DeFi Stable coin Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="/blog/exclusive-complete-guide-decentralized-finance/"
                                        >
                                          DeFi Exchange Development
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link eventKey="wallet" to="#">
                                Wallet
                              </Nav.Link>
                              {/* Wallet Page Mobile Responsive Links */}
                              <div className="mobile_dropdown">
                                <Tab.Content>
                                  <Tab.Pane
                                    eventKey="wallet"
                                    className="main-menu "
                                  >
                                    <Nav
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Crypto Wallet Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          DeFi Wallet Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Bitcoin Wallet Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Wallet Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Multicurrency Wallet App Development
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </Nav.Item>
                          </Nav>

                          {/* Web3 Development Links */}
                          <div className="desktop_dropdown">
                            <div className="col-md-12">
                              <Tab.Content>
                                <Tab.Pane
                                  eventKey="web3"
                                  className="main-menu "
                                >
                                  <Row>
                                    <Col md={6}>
                                      <Nav
                                        className="main-menu flex-column"
                                        variant="pills"
                                      // style={{ width: "300px" }}
                                      >
                                        <Nav.Item>
                                          <Link
                                            to="/web3-development-company/"
                                            className="d-flex justify-content-between nav-link "
                                          >
                                            <span>
                                              Web3 Development Company
                                            </span>
                                            {utils.linkIcon()}
                                          </Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                          <Link
                                            className="nav-link d-flex justify-content-between "
                                            to="/blog/tokenization-in-revolutionizing-blockchain/"
                                          >
                                            <span>Token Development</span>
                                            {utils.linkIcon()}
                                          </Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                          <Link
                                            className="nav-link"
                                            to="#"
                                            onClick={handleToggleTalkToUs}
                                          >
                                            ICO Development
                                          </Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                          <Link
                                            className="d-flex justify-content-between nav-link "
                                            to="/dao-development-company/"
                                          >
                                            <span>DAO Development</span>
                                            {utils.linkIcon()}
                                          </Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                          <Link
                                            className="d-flex justify-content-between nav-link "
                                            to="/ton-wallet-development-company/"
                                          >
                                            <span>
                                              Ton wallet Development Company
                                            </span>
                                            {utils.linkIcon()}
                                          </Link>
                                        </Nav.Item>
                                      </Nav>
                                    </Col>
                                  </Row>
                                </Tab.Pane>
                              </Tab.Content>
                            </div>
                          </div>
                          {/* Web2 development Links */}
                          <div className="desktop_dropdown">
                            <Tab.Content>
                              <Tab.Pane eventKey="web2" className="main-menu ">
                                <Row>
                                  <Col md={6} className="custom_web2_scroll">
                                    <Nav
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-between nav-link"
                                          to="/custom-web-development-company/"
                                        >
                                          <span>
                                            Custom Web Design & Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          UI / UX Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-between nav-link"
                                          to="/blog/ecommerce-automotive-industry/"
                                        >
                                          <span>E-Commerce Development</span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Mobile App Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-between nav-link"
                                          to="/stock-trading-app-development-company/"
                                        >
                                          Stock Trading Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                  <Col md={6}>
                                    <Nav
                                      // style={{
                                      //   width: "300px",
                                      // }}
                                      className="main-menu flex-column"
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-between nav-link"
                                          to="/mean-and-mern-full-stack-development/"
                                        >
                                          MEAN / MERN Stack Development
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-between nav-link"
                                          to="/poc-development-company/"
                                        >
                                          POC Open Source Development{" "}
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          QA Testing
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link d-flex justify-content-between "
                                          to="/blog/how-to-build-software-product-guide-for-beginners/"
                                        >
                                          <span>
                                            Demand based Web Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                </Row>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                          {/* Crypto Exchange development Links */}
                          <div className="desktop_dropdown">
                            <Tab.Content>
                              <Tab.Pane eventKey="crypto" className="main-menu">
                                <Row>
                                  <Col md={6} className="custom_crypto_scroll">
                                    <Nav
                                    // style={{
                                    //   width: "300px",
                                    // }}
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link "
                                          to="/cryptocurrency-exchange-development-company/"
                                        >
                                          <span>
                                            Cryptocurrency Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link "
                                          to="/centralized-crypto-exchange-development/"
                                        >
                                          <span>
                                            Centralized Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link "
                                          to="/decentralized-exchange-development/"
                                        >
                                          <span>
                                            Decentralized Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link"
                                          to="/p2p-crypto-exchange-development/"
                                        >
                                          <span>
                                            P2P Crypto Exchange Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                  <Col
                                    md={6}
                                  // style={{
                                  //   width: "300px",
                                  // }}
                                  >
                                    <Nav className="d-flex flex-column ">
                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-center nav-link"
                                          to="/smart-contract-development-company/"
                                        >
                                          <span>
                                            Smart Contract Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-center nav-link"
                                          to="/white-label-crypto-exchange-development/"
                                        >
                                          <span>
                                            White-Label Crypto Exchange
                                            Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Crypto Banking Software
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                </Row>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                          {/* MLM Development */}
                          <div className="desktop_dropdown">
                            <Tab.Content>
                              <Tab.Pane eventKey="mlm" className="main-menu ">
                                <Nav
                                  className="main-menu flex-column"
                                  variant="pills"
                                >
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="/cryptocurrency-mlm-software-development/"
                                    >
                                      Crypto MLM Software Development
                                      {utils.linkIcon()}
                                    </Link>
                                  </Nav.Item>
                                </Nav>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                          {/* Blockchain Development Links */}
                          <div className="desktop_dropdown">
                            <Tab.Content>
                              <Tab.Pane
                                eventKey="blockchain"
                                className="main-menu "
                              >
                                <Row>
                                  <Col md={6} className="custom_scroll">
                                    <Nav
                                      // style={{ width: "300px" }}
                                      className="flex-column"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="d-flex align-items-center justify-content-center nav-link"
                                          to="/enterprise-blockchain-development/"
                                        >
                                          <span>
                                            Enterprise Blockchain Development{" "}
                                            {utils.linkIcon()}
                                          </span>
                                        </Link>
                                      </Nav.Item>

                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain Consulting & Development
                                          Service
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="d-flex justify-content-center nav-link"
                                          to="/web3-smart-contract-development-company/"
                                        >
                                          <span>
                                            Smart Contract Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Private Blockchain Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Hybrid Finance Blockchain Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Layer 1 and Layer 2 Solutions
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link d-flex align-items-center  justify-content-between "
                                          to="/blog/blockchain-supply-chain/"
                                        >
                                          <span>Blockchain in Supplychain</span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                  <Col md={6}>
                                    <Nav
                                      className="flex-column"
                                    // style={{ width: "300px" }}
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link d-flex justify-content-between "
                                          to="/blog/blockchain-in-pharma-industry/"
                                        >
                                          <span>Blockchain in Healthcare</span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain in Realestate
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain in Insurance
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Protocol Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Blockchain Frameworks
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Binance smart chain Blockchain
                                          Development
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                </Row>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                          {/* NFT Development Links */}
                          <div className="desktop_dropdown">
                            <Tab.Content>
                              <Tab.Pane eventKey="nft" className="main-menu ">
                                <Row>
                                  <Col md={6} className="custom_nft_scroll">
                                    <Nav
                                      className="main-menu flex-column"
                                      // style={{
                                      //   width: "100%",
                                      //   maxWidth: "300px",
                                      // }}
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link d-flex justify-content-between"
                                          to="/nft-development-company/"
                                        >
                                          <span>NFT Development Company</span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link d-flex justify-content-between"
                                          to="/nft-marketplace-development-company/"
                                        >
                                          <span>
                                            NFT Marketplace Development
                                          </span>
                                          {utils.linkIcon()}
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Gaming Platform Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Staking platform Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Minting platform Development
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                  <Col md={6}>
                                    <Nav
                                      className="main-menu flex-column"
                                      // style={{
                                      //   width: "100%",
                                      //   maxWidth: "300px",
                                      // }}
                                      variant="pills"
                                    >
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Smart Contract Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Marketplace platform like Opensea
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          Polygon NFT Marketplace Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Exchange Development
                                        </Link>
                                      </Nav.Item>
                                      <Nav.Item>
                                        <Link
                                          className="nav-link"
                                          to="#"
                                          onClick={handleToggleTalkToUs}
                                        >
                                          NFT Token Development
                                        </Link>
                                      </Nav.Item>
                                    </Nav>
                                  </Col>
                                </Row>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                          {/* DeFi Development Links */}
                          <div className="desktop_dropdown">
                            <Tab.Content>
                              <Tab.Pane eventKey="defi" className="main-menu ">
                                <Nav
                                  className="main-menu flex-column"
                                  variant="pills"
                                >
                                  <Nav.Item>
                                    <Link
                                      className="nav-link d-flex justify-content-between align-items-center"
                                      to="/defi-development-company/"
                                    >
                                      <span>DeFi Development Company</span>
                                      {utils.linkIcon()}
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      DeFi Smart Contract Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      DeFi Yield Farming Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      DApp Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      DeFi Token Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      DeFi Stable Coin Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link d-flex align-items-center justify-content-between "
                                      to="/blog/exclusive-complete-guide-decentralized-finance/"
                                    >
                                      <span>DeFi Exchange Development</span>
                                      {utils.linkIcon()}
                                    </Link>
                                  </Nav.Item>
                                </Nav>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                          {/* Wallet Page Links */}
                          <div className="desktop_dropdown">
                            <Tab.Content>
                              <Tab.Pane
                                eventKey="wallet"
                                className="main-menu "
                              >
                                <Nav
                                  className="main-menu flex-column"
                                  variant="pills"
                                >
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      Crypto Wallet Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      DeFi Wallet Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      Bitcoin Wallet Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      NFT Wallet Development
                                    </Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Link
                                      className="nav-link"
                                      to="#"
                                      onClick={handleToggleTalkToUs}
                                    >
                                      Multicurrency Wallet App Development
                                    </Link>
                                  </Nav.Item>
                                </Nav>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                        </Tab.Container>
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            </Row>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
      <TalkToUs
        show={talkToUsShow}
        onHide={handleToggleTalkToUs}
        closeButton={true}
        size={"lg"}
        backdrop="static"
        keyboard={false}
      >
        <div className="screen__content">
          <form onSubmit={handleSubmit(handleOnSubmit)} className="login">
            <div className="login__field">
              <i className="login__icon fas fa-user"></i>
              <input
                type="text"
                className="login__input"
                {...register("name")}
                placeholder="Your Name"
              />
              <p className="text-danger mb-0">{errors.name?.message}</p>
            </div>
            <div className="login__field">
              <input
                type="email"
                className="login__input"
                {...register("email")}
                placeholder="Email"
              />
              <p className="text-danger mb-0">{errors.email?.message}</p>
            </div>
            <div className="login__field">
              <input
                type="text"
                className="login__input"
                placeholder="Teams / Mobile / Whatsapp"
                {...register("mobile")}
              />
              <p className="text-danger mb-0">{errors.mobile?.message}</p>
            </div>
            <div className="login__field">
              <select className="login__input" {...register("country")}>
                <option value="">Select Country</option>
                {countries.map((ele, ind) => {
                  return (
                    <option key={ind} value={ele.isoCode}>
                      {ele.name}
                    </option>
                  );
                })}
              </select>
              <p className="text-danger mb-0">{errors.country?.message}</p>
            </div>
            <div className="login__field">
              <select className="login__input" {...register("service")}>
                <option value="">Select your services</option>
                <option value="crypto exchange development">
                  Crypto Exchange Development
                </option>
                <option value="nft marketplace development">
                  NFT Marketplace Development
                </option>
                <option value="defi development">DeFi Development</option>
                <option value="metaverse development">
                  Metaverse Development
                </option>
                <option value="blockchain solutions">
                  Blockchain Solutions
                </option>
                <option value="web 3.0 development">Web 3.0 Development</option>
                <option value="crypto wallet development">
                  Crypto Wallet Development
                </option>
                <option value="custom software development">
                  Custom Software Development
                </option>
                <option value="mobile app development services">
                  Mobile App Development Services
                </option>
                <option value="artificial intelligence solutions">
                  Artificial Intelligence Solutions
                </option>
                <option value="others"> Others</option>
              </select>
              <p className="text-danger mb-0">{errors.service?.message}</p>
            </div>
            <div className="login__field">
              <textarea
                id="content"
                placeholder="Type content here"
                rows={5}
                className="login__input"
                {...register("content")}
                maxLength={500}
              ></textarea>
              <p className="text-danger mb-0">{errors.content?.message}</p>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="button login__submit"
            >
              <span className="button__text">
                {" "}
                Submit {loading && <Loading />}
              </span>
              <i className="button__icon fas fa-chevron-right"></i>
            </button>
          </form>
        </div>
        <div className="screen__background">
          <span className="screen__background__shape screen__background__shape4"></span>
          <span className="screen__background__shape screen__background__shape3"></span>
          <span className="screen__background__shape screen__background__shape2"></span>
          <span className="screen__background__shape screen__background__shape1"></span>
        </div>
      </TalkToUs>
    </Fragment>
  );
};

export default LandingHeader;
